import tw, { styled } from "twin.macro";

export const StyledDigitCodeWrapper = styled.div`
  ${tw`flex gap-m`}
`;
